import { TaxUsageType } from "types/generated/models";

export function applyTax(taxUsage: TaxUsageType, amount: number, taxRate?: number | null): number {
    if (taxUsage !== TaxUsageType.Excluding || !taxRate) {
        return amount;
    }

    return amount * (1 + taxRate);
}
